<app-announcement-widget hideByChannel="public-important"></app-announcement-widget>
